import { gql } from '@web/gql'

export const reviewGroupAndMissionGroupsQuery = gql(`
  query ReviewGroupAndMissionGroups($id: ID!) {
    reviewGroup(id: $id) {
      ... on ReviewGroupSucceed {
        __typename
        reviewGroup {
          ...ReviewGroupComplete_ReviewGroup
        }
      }
    }

    notificationMissionGroups(reviewGroupId: $id) {
      ... on MissionGroupsSucceed {
        missionGroups {
          ...MissionCard_MissionGroup
        }
      }
      ... on BaseError {
        message
      }
    }
  }
`)

export const ReviewGroupComplete_ReviewGroup_Fragment = gql(/* GraphQL */ `
  fragment ReviewGroupComplete_ReviewGroup on ReviewGroup {
    id
    place {
      id
      locationText
      type
      isKoreaHotel
      naverHotelId
      dongName
      cityName
      ...RecommendPlaceCard_Place
    }
    ...MyReviewCard_ReviewGroup
    mediaItems {
      ...ContributionCard_MediaItems
    }
  }
`)

export const reviewGroupWriteStatQuery = gql(`
  query ReviewGroupWriteStat($id: ID!, $includePlaceStat: Boolean!) {
    reviewGroupWriteStat(reviewGroupdId: $id, debugMode: true) {
      ... on ReviewGroupWriteStat_Succeed {
        reviewGroupUserStat {
          ...Title_ReviewGroupUserStat
        }
        reviewGroupPlaceStat @include(if: $includePlaceStat) {
          ...ReviewGroupComplete_ReviewGroupPlaceStat
        }
      }
      ... on BaseError {
        message
      }
      ... on UnknownError {
        message
      }
    }
  }
  
  fragment ReviewGroupComplete_ReviewGroupPlaceStat on ReviewGroupPlaceStat {
    ...MyReviewCard_ReviewGroupPlaceStat
    ...ContributionCard_ReviewGroupPlaceStat
  }
`)

export const overseasAttractionRecommendsQuery = gql(`
  query OverseasAttractionRecommends($cityName: String!) {
    overseasAttractionRecommends(cityName: $cityName) {
      ... on OverseasAttractionRecommends_Succeed {
        overseasAttractionRecommends {
          ...RecommendAttractionCard_OverseasAttractionRecommends
        }
      }
      ... on BaseError {
        message
      }
    }
  }
`)

export const overseasHotelRecommendsQuery = gql(`
  query OverseasHotelnRecommends($hotelId: String!) {
    overseasHotelRecommends(hotelId: $hotelId) {
      ...on OverseasHotelRecommends_Succeed {
        overseasHotelRecommends {
          ...RecommendHotelCard_OverseasHotelRecommends
        }
      }
      ... on BaseError {
        message
      }
    }
  }
`)
